import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

const store = {
  state: {
    formatos: {},
  },
  getters: {
    formatos: state => {
      return state.formatos
    },
  },
  mutations: {
    ASIGNA_FORMATOS(state, formatos) {
      state.formatos = formatos
    },
  },
  actions: {

    guardarFormato({ getters }, formato) {
          return new Promise((resolve, reject) => {
            db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.FORMATOS)
            .add(formato).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            })
          })
    },
    actualizaFormato({ getters }, data) {
      var {formato, idFormato} = data;
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.FORMATOS)
        .doc(idFormato).update(formato).then(() => {
            resolve();
        }).catch(error => {
            reject(error);
        })
      })
    },
    cargaFormatos({ commit, getters }) {
      return new Promise((resolve) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.INDICES)
        .doc(FS_COLLECTIONS.FORMATOS).onSnapshot(doc => {
            let formatos = doc.exists ? doc.data() : {}
            commit('ASIGNA_FORMATOS', formatos)
            resolve()
        })
      })
    },
    cargaFormato({getters }, idFormato) {
        return new Promise((resolve, reject) => {
          db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.FORMATOS)
          .doc(idFormato).get().then(doc => {
              resolve(doc.data())
          }).catch(error => {
              reject(error)
          })
        })
      },
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/formatos/formatos.js